<template>
  <div
    class="info-tooltip-container"
    ref="tooltip"
    @mouseenter="visible = true"
    @mouseleave="visible = false"
  >
    <span class="info-icon">
      <img
        class="icon-in-button"
        :src="require('@/assets/dashboard/circle-info-solid-dark-grey.svg')"
        alt="Icon"
      />
    </span>
    <div v-if="visible" class="info-popup">
      {{ text }}
    </div>
  </div>
</template>

<script>

export default {
  props: {
    text: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    togglePopup() {
      this.visible = !this.visible;
    },
    handleClickOutside(event) {
      if (this.visible && !this.$refs.tooltip.contains(event.target)) {
        this.visible = false;
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>

<style scoped src="@/styles/InfoTooltip.css">

</style>